import type { ICellRendererParams } from 'ag-grid-community';
import type { Forecast } from '../../schema';

function formatRupees(v: number | null): string {
  if (v == null) return '—';
  return v.toLocaleString('en-IN', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });
}

// Min – Max range with em-dash placeholder per side. Right-aligned so the
// numbers line up under each other (sortable digits).
export function PredictedRangeCell(p: ICellRendererParams<Forecast>) {
  if (!p.data) return null;
  const { predictedMin, predictedMax } = p.data;
  return (
    <span className="block w-full text-right tabular-nums text-[13px] text-foreground">
      <span className={predictedMin == null ? 'text-border-strong' : ''}>
        {formatRupees(predictedMin)}
      </span>
      <span className="mx-1 text-foreground-muted">–</span>
      <span className={predictedMax == null ? 'text-border-strong' : ''}>
        {formatRupees(predictedMax)}
      </span>
    </span>
  );
}
